import React from 'react';

import { DataTestId } from '@utils/test';

type TimeSlotSelectorProps = {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  claimedSlots: Set<number>;
  totalSlots: number;
  onSelectorClick: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
  setDefaultX: () => void;
  handleMouseMove: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
  height: number;
  width: number;
};

export function TimeSlotSelector(props: TimeSlotSelectorProps) {
  const { canvasRef, setDefaultX, onSelectorClick, handleMouseMove, height, width } = props;

  return (
    <div>
      <canvas
        data-testid={DataTestId.SET_TIMESLOT_MODAL_WAVEFORM}
        style={{
          height: height,
          display: 'block',
          cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
        }}
        ref={canvasRef}
        height={height}
        width={width}
        onBlur={setDefaultX}
        onMouseOut={setDefaultX}
        onMouseMove={handleMouseMove}
        onClick={onSelectorClick}
      />
    </div>
  );
}
